import React, { useContext, useEffect, useState } from "react";
import "./Progress_Query.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllProgessQuery,
  SubmitQueryReminder,
} from "../../features/support/slice";
import { formatNotifDate } from "../../utils/common";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import No_data from "../Common/No_data/No_data";

function Progress_Query() {
  const data1 = [
    {
      title: "Activity Bonus",
      status: "Rejected",
      time: "2026-03-23 13:05:30",
      order: "2603230735301872379",
      message: "Hello, Please fill in the bonus you want to claim. Thank you",
    },
    {
      title: "Add USDT Address",
      status: "Rejected",
      time: "2026-03-23 12:55:36",
      order: "2603230725366385680",
      message:
        "Please provide all necessary requirements needed to add your USDT address, and resubmit another request.",
    },
    {
      title: "Deposit Not Received",
      status: "Rejected",
      time: "2026-03-23 10:03:45",
      order: "2603230433452533579",
      message:
        "Hello, Please provide the PDF file showing payment UTR 644447198593. Thank You",
    },
    {
      title: "Deposit Not Received",
      status: "Rejected",
      time: "2026-03-23 09:02:23",
      order: "2603230332231651395",
      message:
        "Hello, Please provide a clear video record of your bank statement using 2 different devices and attach the PDF file showing payment UTR 644447198593. Thank You",
    },
    {
      title: "Withdrawal Problem",
      status: "Success",
      time: "2026-03-19 14:50:04",
      order: "2603190920047607196",
      message:
        "Your withdrawal successful. Please allow 72 hours (3 day) for this amount to be received. Thank you",
    },
  ];
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [disabledReminders, setDisabledReminders] = useState([]);
  const handleReminder = (orderNumber) => {
    setDisabledReminders((prev) => [...prev, orderNumber]);
  };
  const dispatch = useDispatch();

  const data = useSelector((state) => state.support);

  useEffect(() => {
    dispatch(GetAllProgessQuery());
  }, [dispatch]);

  const SendReminderQuery = async (order_number) => {
    const formData = new FormData();
    formData.append("order_number", order_number);
    const res = await dispatch(SubmitQueryReminder(formData));

    if (res.meta?.requestStatus === "fulfilled") {
      await handleReminder(order_number);
      setModalMessage(res?.payload?.data || "Reminder Sent Successfully");
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
        setModalMessage();
      }, 2000);
    } else {
      setModalMessage(
        res?.payload?.errors || "Submission failed. Please try again",
      );
      setModalShow(true);
      setTimeout(() => setModalShow(false), 3000);
    }
  };

  return (
    <>
      <section className="Progress_Query">
        <Common_white_header headingText={"Progress Query"} />
        <div className="container">
          <div className="activity_container">
            {data?.data?.length > 0 ? (
              data.data.map((item, index) => (
                <div className="activity_card" key={index}>
                  <div className="activity_header">
                    <h4>{item.query_type}</h4>
                    <span
                      className={`status ${
                        item.status === "Rejected"
                          ? "rejected"
                          : item.status === "Accepted"
                          ? "success"
                          : "pending"
                      }`}
                    >
                      {item.status}
                    </span>
                  </div>

                  <p className="meta">
                    Time: {formatNotifDate(item.createdAt)}
                  </p>
                  <p className="meta">Order: {item.order_number || "N/A"}</p>

                  {item?.remark && (
                    <div className="message_box">{item.remark}</div>
                  )}

                  {item.status === "Processing" && (
                    <div
                      className={`Progress_orange_btn_ ${
                        disabledReminders.includes(item?.order_number)
                          ? "inactive"
                          : ""
                      }`}
                    >
                      <button
                        className="orange_btn"
                        disabled={disabledReminders.includes(
                          item?.order_number,
                        )}
                        onClick={() => SendReminderQuery(item?.order_number)}
                      >
                        Reminders
                      </button>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <No_data />
            )}
          </div>
        </div>
        <Successfull_strip_modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          textMsg={modalMessage}
        />
      </section>
    </>
  );
}

export default Progress_Query;
